
import { computed, defineComponent } from 'vue';

import { useCalculations } from '@/lib/calculationstate';
import { format } from '@/lib/currency';

import CheckBox from '@/components/CheckBox.vue';
import CurrencyInput from '@/components/CurrencyInput.vue';
import Slider from '@/components/Slider.vue';

export default defineComponent({
  name: 'ResultControls',
  components: {
    Slider,
    CurrencyInput,
    CheckBox,
  },
  setup() {
    const calculations = useCalculations();

    const formattedIncome = computed(() => format(calculations.extraMonthlyIncome.value));

    return {
      ...calculations,
      formattedIncome,
    };
  },
});
